import { render } from "./ChartJsChart.vue?vue&type=template&id=c063aa64&ts=true"
import script from "./ChartJsChart.vue?vue&type=script&lang=ts"
export * from "./ChartJsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__